export const versionList = (() => {
  const list = [{ name: "Toutes", id: 0 }];
  let nextId = 1;

  // Génère V2.0 → V2.9, V3.0 → V3.9, …, V9.0 → V9.9
  for (let major = 1; major <= 9; major++) {
    for (let minor = 0; minor <= 9; minor++) {
      list.push({
        name: `V${major}.${minor}`,
        id: nextId++,
      });
    }
  }

  return list;
})();

export const dateList = (() => {
  const list = [{ name: "Toutes", id: 0 }];
  let nextId = 1;

  // Génère des mois de l’année en cours à 2020, au format YYYY-MM
  const startYear = new Date().getFullYear();
  const endYear = 2024;

  for (let year = startYear; year >= endYear; year--) {
    // Si on est sur l’année en cours, on s’arrête au mois actuel
    const maxMonth = year === startYear ? new Date().getMonth() + 1 : 12;

    for (let month = maxMonth; month >= 1; month--) {
      const mm = String(month).padStart(2, "0");
      list.push({
        name: `${mm}-${year}`,
        id: nextId++,
      });
    }
  }

  return list;
})();

export const organismeData = [
  { name: "Toutes", id: 1 },
  { name: "CEISNA", id: 2 },
];

export const statusData = [
  { name: "Actif", id: 1 },
  { name: "Encours de renouvellement", id: 2 },
  { name: "Expiré", id: 3 },
];

export const certificatType = [
  { name: "Certificats Organismes", id: 1 },
  { name: "Certificats Promoteurs", id: 2 },
];
